import Vue from "vue";
import Root from "../views/Home.vue";
import "../assets/js/common";
import GameLink from "../components/game-link.vue";
import Ads from "../components/ads.vue";
import "../assets/css/common.less";
import Rate from "../components/rate.vue";
import Footer from "../components/footer.vue";
Vue.component("game-link", GameLink);
Vue.component("ads", Ads);
Vue.component("rate", Rate);
Vue.component("rush-footer", Footer);
new Vue({
    render: (h) => h(Root),
}).$mount("#app");
